import { LoggedInUserContext } from "../context/loggedInUserContext";
import { API_Endpoints } from "./API_Endpoints";
import axiosInstance from "./axios";

export const AddCategoryService = (data: {
  name: string;
  description: string;
}) => {
  return axiosInstance
    .post(API_Endpoints.Admin.ADD_CATEGORY, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const GetCategoriesService = (page?: number) => {
  return axiosInstance
    .get(`${API_Endpoints.Admin.ADD_CATEGORY}?page=${page}&limit=10`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetCategoryDetailService = (id: string) => {
  return axiosInstance
    .get(`${API_Endpoints.Admin.ADD_CATEGORY}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const UpdateCategoryService = (id: any, data: any) => {
  return axiosInstance
    .put(`${API_Endpoints.Admin.GET_CATEGORY_DETAIL}/${id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};

export const DeleteCategoryService = (id: any) => {
  return axiosInstance
    .delete(`${API_Endpoints.Admin.GET_CATEGORY_DETAIL}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetUserCategories = () =>{
  return axiosInstance
  .get(`${API_Endpoints.Categories.GET_CATEGORIES}`)
  .then((res) => res.data)
  .catch((err) => err);
}
